import { Button } from 'bold-ui'
import { usePecField } from 'components/form/core/hooks/useField'
import { Meta } from 'util/metaPath'

interface CheckButtonFieldProps {
  name: Meta<number> | Meta<string>
  originalValue?: number
  children: any
  disabled?: boolean
  dataTestId?: string
}

export default function CheckButtonField({
  name,
  originalValue,
  children,
  disabled,
  dataTestId,
}: CheckButtonFieldProps) {
  const {
    input: { value, onChange },
  } = usePecField<string | number>({ name })

  return (
    <div>
      <Button
        onClick={() => onChange(originalValue)}
        kind={value === originalValue ? 'primary' : 'normal'}
        skin='default'
        size='small'
        disabled={disabled}
        data-cy={dataTestId}
      >
        {children}
      </Button>
    </div>
  )
}
